import React from 'react';
import { PARAMS } from "../../../../config";
const style = { fontSize: '18px', fontWeight: 'bold' };

const Total = ({ data, quality }) => {
    let td = getValues(data);

    if(quality) td.push(<td style={style} key={'rD'} />);

    return (
        <tr>
            <td colSpan={3}>Total</td>
            {td}
        </tr>
    );
};

function getValues(row) {
    return PARAMS.map(([ param ]) => {
        const value = row[param];

        return (<td style={style} key={param}>{value}</td>);
    });
}

export default Total;



// WEBPACK FOOTER //
// ./src/scenes/AdKernelHourly/components/Table/components/TotalRow/index.js